import React, { createContext, useContext, ReactNode } from "react"

interface AlertContextType {
  // Add alert-specific context values as needed
}

const AlertContext = createContext<AlertContextType | undefined>(undefined)

export function useAlertContext() {
  const context = useContext(AlertContext)
  if (context === undefined) {
    throw new Error("useAlertContext must be used within an AlertProvider")
  }
  return context
}

interface AlertProviderProps {
  children: ReactNode
}

export function AlertProvider({ children }: AlertProviderProps) {
  const value: AlertContextType = {
    // Add context values as needed
  }

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
}

export default AlertProvider